import { ReactComponent as CloseIcon } from '@assets/icons/close.svg';

import {
  Button,
  Flex,
  Text,
  useBreakpointValue,
  useTheme
} from '@chakra-ui/react';

interface ProviderHeaderProps {
  serviceName: string;
  onRemoveService: () => void;
  isRemoveDisabled?: boolean;
}

const ProviderHeader = ({
  serviceName,
  isRemoveDisabled = false,
  onRemoveService
}: ProviderHeaderProps) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const {
    colors: {
      palette: {
        booking: {
          stepService: {
            providerList: { providerHeader }
          }
        }
      }
    }
  } = useTheme();

  return (
    <Flex alignItems='center' gap='17px'>
      <Button
        display={isRemoveDisabled ? 'none' : 'block'}
        onClick={onRemoveService}
        bg='transparent'
        borderRadius={0}
        h='100%'
        padding={0}
        mt='1px'
        minWidth='30px'
        _hover={{
          opacity: 0.5
        }}
        _active={{
          background: 'transparent'
        }}
      >
        <CloseIcon
          fill={providerHeader.closeIconFill}
          width={isMobile ? 12 : 16}
          height={25}
        />
      </Button>
      <Text
        fontSize={{ base: '20px', md: '22px', lg: '25px' }}
        fontWeight='400'
        color={providerHeader.textColor}
        lineHeight='140%'
      >
        {serviceName}
      </Text>
    </Flex>
  );
};

export default ProviderHeader;
